import NoDataFoundIcon from "Assets/Icons/NoDataFoundIcon";
import NoResultFoundSearch from "Components/CommonComponents/NoResultFoundSearch/NoResultFoundSearch";
import Typography from "Components/CommonComponents/Typography";
import { Spinner } from "reactstrap";
import "../index.css";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import RightArrow from "Assets/Icons/RightArrow";
export interface ChapterListViewComponentInterface {
  chapterList: any[];
  isChapterListLoader: boolean;
  selectedChapter: any;
  setSelectedChapter: any;
  togglePane?: any;
}
const ChapterListViewComponent = ({
  chapterList,
  isChapterListLoader,
  selectedChapter,
  setSelectedChapter,
  togglePane,
}: ChapterListViewComponentInterface) => {
  const { screen }: any = useWindowSize();
  return (
    <>
      <div className="lecCol p-0">
        <Typography
          variant={["xxl", "xl", "lg"].includes(screen) ? "h4" : "h6"}
          color="black"
        >
          Chapters List
        </Typography>
      </div>
      {isChapterListLoader ? (
        <div className="chapterListViewLoading">
          <Spinner color="info"></Spinner>
        </div>
      ) : (
        <>
          {chapterList.length == 0 ? (
            <div className="mt-4 mb-8">
              <NoResultFoundSearch
                primaryMessage="No chapters present"
                secondaryMessage={"We cannot found any chapters here"}
              >
                <NoDataFoundIcon />
              </NoResultFoundSearch>
            </div>
          ) : (
            <div
              className={
                ["xxl", "xl", "lg"].includes(screen)
                  ? "chapterListingMainDiv"
                  : "chapterListingMainDivMB"
              }
            >
              {chapterList.map((ele: any, index: number) => {
                return (
                  <div
                    key={index}
                    className={
                      selectedChapter != null &&
                      selectedChapter.sequence === ele.sequence
                        ? "chapterListDiv lecCol"
                        : "chapterListDivUnselected lecCol"
                    }
                    onClick={() => {
                      setSelectedChapter(ele);
                      togglePane();
                    }}
                  >
                    <div className="d-flex">
                      <Typography variant="subheading3" color="black">
                        {index + 1}
                      </Typography>
                      <span className="ml-2">
                        <Typography variant="subheading3" color="black">
                          {ele?.title}
                        </Typography>
                      </span>
                    </div>
                    <div>
                      <RightArrow />
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </>
      )}
    </>
  );
};
export default ChapterListViewComponent;
